/* Red Line collection pages: quick add with a quantity stepper, caliber chips inside the sticky
   Filter/Sort rail, and the About block's brand sentence corrected from the in-stock cards.
   Loaded by sections/main-collection-product-grid.liquid. */
(function () {
  'use strict';

  var root = document.querySelector('main#MainContent');
  if (!root) return;

  /* ---------- Quick add (single-size products) ---------- */

  var cartState = {};      // variantId -> quantity in cart
  var busy = new Set();

  function jsonFetch(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function announceCart() {
    window.SubscriptionInsuranceCore && window.SubscriptionInsuranceCore.clearCartCache && window.SubscriptionInsuranceCore.clearCartCache();
    ['cart:refresh', 'cart:updated'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
  }

  // Same path as the product form: ask the insurance core for the line that fits the new subtotal,
  // and add it in the same request. If the core is unavailable, the site's global auto-sync covers it.
  function insuranceItemFor(priceCents) {
    var core = window.SubscriptionInsuranceCore;
    var settings = (window.theme && theme.shopSettings) || {};
    if (!settings.shippingInsuranceEnabled || !core || !core.determineInsuranceAction || !core.executeInsuranceAction || !priceCents) {
      return Promise.resolve(null);
    }
    return core.determineInsuranceAction(false, null, { merchandiseSubtotalDelta: priceCents })
      .then(function (action) { return core.executeInsuranceAction(action); })
      .catch(function () { return null; });
  }

  // After a quantity change: an insurance line left with no merchandise goes, and the tier follows the new subtotal
  function insuranceIds() {
    var settings = (window.theme && theme.shopSettings) || {};
    return (settings.shippingInsuranceVariantIds || [settings.shippingInsuranceVariantId])
      .map(function (v) { return String(parseInt(v, 10)); })
      .filter(function (v) { return v !== 'NaN'; });
  }

  function reconcileInsurance(cart) {
    var ids = insuranceIds();
    var items = cart.items || [];
    var insurance = items.filter(function (it) { return ids.indexOf(String(it.variant_id)) !== -1; });
    var merch = items.filter(function (it) { return ids.indexOf(String(it.variant_id)) === -1; });
    if (!merch.length && insurance.length) {
      var updates = {};
      insurance.forEach(function (it) { updates[it.key] = 0; });
      return jsonFetch('/cart/update.js', { updates: updates }).catch(function () {});
    }
    var core = window.SubscriptionInsuranceCore;
    if (!merch.length || !core || !core.determineInsuranceAction || !core.executeInsuranceAction) return Promise.resolve();
    if (core.clearCartCache) core.clearCartCache();
    return core.determineInsuranceAction(false, null)
      .then(function (action) { return core.executeInsuranceAction(action); })
      .then(function (item) { return item ? jsonFetch('/cart/add.js', { items: [item] }) : null; })
      .catch(function () {});
  }

  function stepperHtml(qty) {
    return '<button type="button" class="pa-rl-qty__btn" data-step="-1" aria-label="Remove one">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11h16v2H4z" fill="currentColor"/></svg></button>' +
      '<span class="pa-rl-qty__n" aria-live="polite">' + qty + '</span>' +
      '<button type="button" class="pa-rl-qty__btn" data-step="1" aria-label="Add one">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 4h2v16h-2zM4 11h16v2H4z" fill="currentColor"/></svg></button>';
  }

  function renderSlot(button) {
    var id = button.dataset.variantId;
    var slot = button.parentElement;
    var stepper = slot.querySelector('.pa-rl-qty');
    var qty = cartState[id] || 0;
    if (qty > 0) {
      if (!stepper) {
        stepper = document.createElement('div');
        stepper.className = 'pa-rl-qty';
        stepper.dataset.variantId = id;
        slot.appendChild(stepper);
      }
      stepper.innerHTML = stepperHtml(qty);
      stepper.setAttribute('aria-label', qty + ' in cart');
      button.hidden = true;
    } else {
      if (stepper) stepper.remove();
      button.hidden = false;
    }
  }

  function renderAll(id) {
    root.querySelectorAll('.pa-rl-qa[data-variant-id' + (id ? '="' + id + '"' : '') + ']').forEach(renderSlot);
  }

  function add(button) {
    var id = button.dataset.variantId;
    if (!id || busy.has(id)) return;
    busy.add(id);
    button.setAttribute('aria-busy', 'true');
    insuranceItemFor(parseInt(button.dataset.priceCents, 10) || 0)
      .then(function (insurance) {
        var items = [{ id: parseInt(id, 10), quantity: 1 }];
        if (insurance) items.push(insurance);
        return jsonFetch('/cart/add.js', { items: items });
      })
      .then(function () {
        cartState[id] = (cartState[id] || 0) + 1;
        renderAll(id);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: { variant_id: id } } }));
        announceCart();
      })
      .catch(function (err) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: (err && err.description) || 'Could not add to cart.' } }));
      })
      .finally(function () {
        busy.delete(id);
        button.removeAttribute('aria-busy');
      });
  }

  function step(stepper, delta) {
    var id = stepper.dataset.variantId;
    if (!id || busy.has(id)) return;
    var next = Math.max(0, (cartState[id] || 0) + delta);
    busy.add(id);
    stepper.setAttribute('aria-busy', 'true');
    // Quantity changes go through /cart/change; the site's insurance auto-sync re-checks the tier after it.
    jsonFetch('/cart/change.js', { id: String(id), quantity: next })
      .then(function (cart) {
        var line = (cart.items || []).find(function (it) { return String(it.variant_id) === String(id); });
        cartState[id] = line ? line.quantity : 0;
        renderAll(id);
        return reconcileInsurance(cart);
      })
      .then(announceCart)
      .catch(function (err) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: (err && err.description) || 'Could not update the cart.' } }));
      })
      .finally(function () {
        busy.delete(id);
        stepper.removeAttribute('aria-busy');
      });
  }

  // Capture phase, so the theme's generic add-to-cart handler doesn't also fire for these buttons.
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var qa = event.target.closest('main#MainContent button.pa-rl-qa');
    if (qa) {
      event.preventDefault();
      event.stopImmediatePropagation();
      add(qa);
      return;
    }
    var btn = event.target.closest('main#MainContent .pa-rl-qty__btn');
    if (btn) {
      event.preventDefault();
      step(btn.closest('.pa-rl-qty'), parseInt(btn.dataset.step, 10));
    }
  }, true);

  function syncFromCart() {
    if (!root.querySelector('.pa-rl-qa')) return;
    jsonFetch('/cart.js').then(function (cart) {
      cartState = {};
      (cart.items || []).forEach(function (it) {
        cartState[String(it.variant_id)] = (cartState[String(it.variant_id)] || 0) + it.quantity;
      });
      renderAll();
    }).catch(function () {});
  }
  syncFromCart();
  // Changes made in the cart drawer show up on the grid when the shopper comes back to it.
  ['upcart:cart:updated'].forEach(function (name) { document.addEventListener(name, syncFromCart); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) syncFromCart(); });

  /* ---------- Caliber chips inside the sticky Filter/Sort rail (phone) ---------- */

  function railChips() {
    var src = document.querySelector('.pa-rl-chips__list');
    var bar = document.querySelector('#main-facet-filters');
    if (!src || !bar || bar.querySelector('.pa-rl-railchips')) return;
    var row = document.createElement('nav');
    row.className = 'pa-rl-railchips';
    row.setAttribute('aria-label', 'Calibers');
    src.querySelectorAll('a').forEach(function (a) {
      var c = document.createElement('a');
      c.href = a.getAttribute('href');
      c.textContent = a.textContent.trim();
      if (a.classList.contains('is-active')) { c.className = 'is-active'; c.setAttribute('aria-current', 'page'); }
      row.appendChild(c);
    });
    bar.appendChild(row);
    var active = row.querySelector('.is-active');
    if (active) row.scrollLeft = Math.max(0, active.offsetLeft - 15);
    // Only once the hero's own chips have scrolled away, so there's never a second row on screen
    var heroChips = document.querySelector('.pa-rl-chips');
    if (heroChips && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('pa-rl-rail--chips', !entries[0].isIntersecting);
      }).observe(heroChips);
    }
  }
  railChips();

  /* ---------- About block: brand sentence from what's actually in stock ---------- */

  function fixAbout() {
    var el = document.querySelector('.collection-seo-description__content');
    if (!el || el.dataset.paFixed) return;
    var brands = ['Federal', 'Winchester', 'Magtech', 'PMC', 'Sellier & Bellot', 'CCI', 'Hornady', 'Remington', 'Fiocchi', 'Aguila', 'Ammo Inc', 'Barnes', 'Norma', 'Sig Sauer', 'HSM', 'TulAmmo', 'Armscor', 'ICC', 'Ruag', 'Sterling', 'Blazer'];
    var seen = [];
    root.querySelectorAll('.flex-grid__item:not(.pa-rl-pick) .card-wrapper:not(.card-wrapper--soldout) .card-information__text, .editorial-product-grid > li .card-wrapper:not(.card-wrapper--soldout) .card-information__text').forEach(function (t) {
      var s = t.textContent.trim().toLowerCase();
      var b = brands.find(function (x) { return s.indexOf(x.toLowerCase()) === 0; });
      if (b && seen.indexOf(b) === -1) seen.push(b);
    });
    var p = el.querySelector('p') || el;
    var text = p.textContent.replace(/\s+/g, ' ').trim();
    var fixed = text;
    if (seen.length) {
      var list = seen.length > 1 ? seen.slice(0, -1).join(', ') + ' and ' + seen[seen.length - 1] : seen[0];
      fixed = fixed.replace(/from top brands like [^.]+\./i, 'from ' + list + '.').replace(/rounds from [^.]+\./i, 'rounds from ' + list + '.');
    } else {
      fixed = fixed.split(/(?<=\.)\s+/).filter(function (s) { return !/in-stock/i.test(s); }).join(' ');
    }
    if (fixed !== text) p.textContent = fixed;
    el.dataset.paFixed = '1';
  }
  fixAbout();
})();
